import { AppointmentDetails } from "components/AppointmentDetails"
import { useTimeOffQuery } from "hooks/useTimeOffQuery";
import { useParams } from "react-router-dom";
import { AppointmentDetailsMenu } from "./AppointmentDetailsMenu";
import { useCallback } from "react";
import { useTimeOffInvalidateQuery } from "hooks/useTimeOffInvalidateQuery";
import { AppointmentDetailsToolbox } from "./AppointmentDetailsToolbox";

export const AppointmentDetailsLoader = (props: Props) => {

    const { id } = useParams()
    const { data } = useTimeOffQuery(parseInt(id), true);
    const invalidateTimeOffQuery = useTimeOffInvalidateQuery()

    const handleDeleted = useCallback(() => {
        invalidateTimeOffQuery()
        props.onDeleted?.()
    }, [props])

    return (
        <AppointmentDetails
            {...data}
            toolbox={(
                <AppointmentDetailsToolbox
                    {...data}
                    onDeleted={handleDeleted}
                />
            )}
        />
    )
}

type Props = {
    onDeleted?: () => void
}
